var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31 31 40 20 40C9 40 0 31 0 20C0 9 9 0 20 0C23.6 0 27 1 30 2.6C30.2 2.6 30.2 2.8 30.4 2.8L27.6 6C25.2 4.8 22.6 4 20 4C11.2 4 4 11.2 4 20C4 28.8 11.2 36 20 36C28.8 36 36 28.8 36 20C36 18.4 35.8 16.8 35.2 15.2L38.2 11.8C39.4 14.4 40 17.2 40 20ZM13 14.2L10.2 17L18.6 25.4C19 25.8 19.4 26 20 26C20.6 26 21 25.8 21.4 25.4L38.8 5.2L36 2.4L20 21L13 14.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2b5931b3df10183983f0db7446ff9955.svg";
export { ForwardRef as ReactComponent };